import { render, staticRenderFns } from "./ContentPages.vue?vue&type=template&id=267a13fa"
import script from "./ContentPages.vue?vue&type=script&lang=js"
export * from "./ContentPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports